export default function() {
    this.attributes({
        url: 'data-action-url',
    });

    this.submit = function(e, data, method) {
        var xhr = $.ajax({
            url: this.$node.attr(this.attr.url),
            method: method,
            dataType: 'json',
            data: data,
        });

        xhr.success(
            function() {
                this.trigger('dataActionSuccess');
            }.bind(this)
        );

        return xhr;
    };

    this.after('initialize', function() {
        this.on('uiSubmitActionRequested', this.submit);
    });
}



// WEBPACK FOOTER //
// ./src/web/js/app/mixins/with-data-action.js